import React from 'react';
import { UserInfo } from '../interfaces/IUserInfo';

interface UserContextType {
  // Define your context properties here
  userInfo: UserInfo;
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfo>>;
}

const UserContext = React.createContext<UserContextType>({
  // Set default values for your context properties
  userInfo: {
    userId: '',
    fullName: '',
    email: ''
  },
  setUserInfo: () => {}
});

export default UserContext;